import React, { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import veniceImage from "assets/images/venice.png";
import whodatImage from "assets/images/whodat.png";
import kingsquayImage from "assets/images/kingsquay.jpg";
import shenandoahImage from "assets/images/shenandoah.png";

import SharpWatchMap from "components/SharpWatchMap";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Deployments() {
  const [activeMarkerName, setActiveMarkerName] = useState(null);
  const cardRefs = useRef([]);
  const sliderRef = useRef(null);

  const deployments = [
    {
      name: "Venice and Lime Rock: VK-956",
      date: "10/2023",
      image: veniceImage,
      features: ["Subsea Leak Detection", "Cloud Monitoring"],
    },
    {
      name: "WhoDat: MC-547",
      date: "11/2023",
      image: whodatImage,
      features: [
        "Subsea Leak Detection",
        "Subsea Pump Module (1/2024)",
        "Reporting",
        "Cloud Monitoring",
      ],
    },
    {
      name: "Kings Quay: GC-433",
      date: "3/2023",
      image: kingsquayImage,
      features: ["MCS Monitoring"],
    },
    {
      name: "Shenandoah: WR-52",
      date: "1/2025",
      image: shenandoahImage,
      features: ["Subsea Leak Detection", "HPHT Module", "Reporting", "Cloud Monitoring"],
    },
  ];

  const scrollToCardByName = (name) => {
    const clean = (str) => str.trim().toLowerCase();
    const index = deployments.findIndex((d) => clean(d.name) === clean(name));
    if (index !== -1) {
      sliderRef.current?.slickGoTo(index);
    }
  };

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1536,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Title */}
      <MDBox
        bgColor="rgba(148, 148, 148, 0.07)"
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        borderRadius="lg"
        sx={{
          width: { xs: "90%", md: "70%", lg: "50%" },
          margin: "15px auto",
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0)",
          backdropFilter: "blur(15px)",
        }}
      >
        <h1 style={{ color: "white", fontSize: "40px", textAlign: "center" }}>
          SharpWatch® Deployments
        </h1>
      </MDBox>

      <Grid container spacing={4} justifyContent="center" alignItems="flex-start">
        {/* Map */}
        <Grid item xs={12}>
          <SharpWatchMap activeMarkerName={activeMarkerName} onMarkerClick={scrollToCardByName} />
        </Grid>

        {/* Carousel */}
        <Grid item xs={12}>
          <MDBox mt={2} px={2} sx={{ overflowX: "hidden" }}>
            <Slider ref={sliderRef} {...sliderSettings}>
              {deployments.map((deployment, index) => (
                <MDBox
                  key={index}
                  ref={(el) => (cardRefs.current[index] = el)}
                  px={1}
                  sx={{
                    minWidth: 0,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <MDBox
                    onMouseEnter={() => setActiveMarkerName(deployment.name)}
                    onMouseLeave={() => setActiveMarkerName(null)}
                    bgColor="dark"
                    variant="gradient"
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    width="100%"
                    maxWidth="flex"
                    minHeight="370px"
                    maxHeight="500px"
                    flexShrink={0}
                    p={2}
                    borderRadius="lg"
                    boxShadow="md"
                    sx={{
                      boxShadow: "0px 8px 20px rgba(0, 0, 0, 0)",
                      backdropFilter: "blur(8px)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0px 16px 30px rgba(0, 0, 0, 0)",
                      },
                    }}
                  >
                    <img
                      src={deployment.image}
                      alt={deployment.name}
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        marginBottom: "10px",
                      }}
                    />
                    <div style={{ color: "white" }}>
                      <h3 style={{ margin: 0, fontSize: "20px" }}>{deployment.name}</h3>
                      <p style={{ margin: "4px 0", fontSize: "15px" }}>
                        Deployed: {deployment.date}
                      </p>
                      <ul style={{ paddingLeft: "20px", fontSize: "15px" }}>
                        {deployment.features.map((feature, i) => (
                          <li key={i}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </MDBox>
                </MDBox>
              ))}
            </Slider>
          </MDBox>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default Deployments;
